'use client';

import type React from 'react';

import { Button } from '@components/components/ui/button';
import { ArrowUp } from 'lucide-react';

interface EventLiveTailIndicatorProps {
  count: number;
  onMerge: () => void;
}

export const EventLiveTailIndicator: React.FC<EventLiveTailIndicatorProps> = ({
  count,
  onMerge,
}) => {
  if (count === 0) return null;

  return (
    <div className="flex items-center justify-center border-b border-blue-100 bg-blue-50 px-4 py-2">
      <Button
        variant="ghost"
        size="sm"
        onClick={onMerge}
        className="text-blue-600 hover:text-blue-700 hover:bg-blue-100"
      >
        <ArrowUp className="h-3.5 w-3.5" />
        {count} new event{count !== 1 ? 's' : ''} — click to load
      </Button>
    </div>
  );
};
